<template>
  <color-picker-container
    class="background-color-box-tool-desktop"
    @save="saveColor"
    @input="changeColor"
  />
</template>

<script>
/**
 * This component is cloning BackgroundColorBoxTool but is required to render
 * the backgroundColor picker in the left menu.
 */
import BackgroundColorBoxTool from './BackgroundColorBoxTool';

export default {
  name: 'BackgroundColorBoxToolDesktop',
  extends: BackgroundColorBoxTool,
};
</script>

<style lang="scss" scoped>
.background-color-box-tool-desktop{
    transform: translateX(-10px);
}
</style>
